"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Box2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Box"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _reactIntl = require("react-intl");
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _jsxRuntime = require("react/jsx-runtime");
var _Box;
const SidePanelQrBanner = () => {
  const intl = (0, _reactIntl.useIntl)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box2.default, {
    background: "cloudLight",
    borderRadius: "100",
    padding: "300",
    dataTest: "TopNav-QrBanner",
    margin: {
      bottom: "800"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      inline: true,
      children: [_Box || (_Box = /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box2.default, {
        display: "flex",
        align: "start",
        direction: "column",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          size: "large",
          weight: "bold",
          spaceAfter: "small",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "navbar.account.qr_banner.header"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: "secondary",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
            id: "navbar.account.qr_banner.description"
          })
        })]
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        className: "rounded-150 shadow-fixed",
        alt: intl.formatMessage({
          id: "navbar.account.qr_banner.description"
        }),
        src: "https://images.kiwi.com/common/kiwicom-app-qr-code-navbar.png",
        width: "100px"
      })]
    })
  });
};
var _default = exports.default = SidePanelQrBanner;